import {
  Paragraph,
  SectionType,
  TextRun,
  HeadingLevel,
  ISectionOptions,
} from 'docx'
import highlights from '../common/highlights'
import dateRange from '../common/dateRange'
import { Resume } from '@/types/resume/v1'

const work = ({ work }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Work Experience',
        heading: HeadingLevel.HEADING_2,
      }),
      ...work.filter((workItem) => (workItem.position || workItem.summary || workItem.name))
        .reduce<Paragraph[]>((acc, workItem) => {
          return acc.concat(createWorkItem(workItem))
        }, []),
    ],
  }
}

const createWorkItem = (workItem: Resume.Work): Paragraph[] => {
  const item: Paragraph[] = []
  item.push(
    new Paragraph({
      text: '\n',
    })
  )
  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: workItem.position,
          bold: true,
        }),
        new TextRun({
          text: '    ' + dateRange(workItem.startDate, workItem.endDate, true),
          bold: false,
        }),
      ],
    })
  )

  let work: string[] = []

  if (workItem.name) {
    work.push(workItem.name)
  }

  if (workItem.location) {
    work.push(workItem.location)
  }

  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: work.join(' | '),
          italics: true,
        }),
      ],
    })
  )
  if (workItem.summary) {
    item.push(
      new Paragraph({
        text: '\n',
      })
    )
    item.push(
      new Paragraph({
        text: workItem.summary,
      })
    )
  }
  item.push(...highlights(workItem.highlights))
  return item
}

export default work
